/**
 * @typedef SortableHeader
 * @property {SORT_DIRECTION} sortDirection
 * @property {string|Element} label
 * @property {Function} onSortDirectionChange The first parameter will be
 * a value of SORT_DIRECTION
 */

export const SORT_DIRECTION = {
  NO_SORT: 'NO_SORT',
  ASCENDING: 'ASCENDING',
  DECENDING: 'DECENDING',
}
